import AddChampionshipGenderRequirements from "./AddChampionshipGenderRequirements";

export default AddChampionshipGenderRequirements;
